import React from 'react';

import { useNavigate } from 'react-router-dom';

import { Settings, X } from 'lucide-react';

import { useSubscription } from '../hooks';

interface NoConfigModalProps {
	isOpen: boolean;
	onClose: () => void;
}

const NoConfigModal: React.FC<NoConfigModalProps> = ({ isOpen, onClose }) => {
	const navigate = useNavigate();
	const { subscriptionStatus } = useSubscription();

	// Don't show modal for first-time users (never purchased credits before)
	if (!isOpen || subscriptionStatus?.credits_total === 0) return null;

	return (
		<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
			<div className="bg-white rounded-lg shadow-2xl w-full max-w-lg">
				<div className="flex items-center justify-between p-6 border-b border-gray-200">
					<div className="flex items-center">
						<Settings className="h-6 w-6 text-blue-600 mr-3" />
						<h2 className="text-xl font-semibold text-gray-900">
							Configuration Required
						</h2>
					</div>
					<button
						onClick={onClose}
						className="text-gray-400 hover:text-gray-600 transition-colors"
					>
						<X className="h-6 w-6" />
					</button>
				</div>

				<div className="p-6">
					<p className="text-gray-600 mb-6 leading-relaxed">
						To continue uploading and analyzing statements, you need to create a
						configuration. This will set up your interchange rate settings for
						accurate analysis.
					</p>

					<div className="flex flex-row gap-3">
						<button
							onClick={onClose}
							className="w-full px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
						>
							Cancel
						</button>
						<button
							onClick={() => {
								onClose();
								navigate('/settings?create=true');
							}}
							className="w-full flex items-center justify-center px-4 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 font-medium"
						>
							<Settings className="h-5 w-5 mr-2" />
							Create Configuration
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default NoConfigModal;
